import React from "react";

export const __systemNameLogger = (name: string) => (e: React.MouseEvent) => {
  if (e.altKey) {
    console.info(`🐵 name: ${name}`);
  }
};
